import type { ComponentConfig } from '@measured/puck';
import { Container } from '../layout/Container';

export interface PressEntry {
  outlet: string;
  quote: string;
  url?: string;
}

export interface PressReviewsProps {
  title?: string;
  entries: PressEntry[];
}

export function PressReviews({ title, entries }: PressReviewsProps) {
  if (entries.length === 0) return <></>;
  return (
    <section className="bg-white py-12">
      <Container>
        {title ? (
          <h2 className="mb-6 text-center text-sm font-semibold uppercase tracking-[0.18em] text-stone-500">
            {title}
          </h2>
        ) : null}
        <div className="grid gap-6 md:grid-cols-3">
          {entries.map((e) => (
            <figure key={e.outlet} className="rounded-xl border border-stone-200 p-5">
              <blockquote className="text-sm text-stone-700">« {e.quote} »</blockquote>
              <figcaption className="mt-3 text-sm font-semibold text-brand-700">
                {e.url ? (
                  <a href={e.url} target="_blank" rel="noopener noreferrer" className="hover:underline">
                    {e.outlet} ↗
                  </a>
                ) : (
                  e.outlet
                )}
              </figcaption>
            </figure>
          ))}
        </div>
      </Container>
    </section>
  );
}

export const PressReviewsConfig: ComponentConfig<PressReviewsProps> = {
  fields: {
    title: { type: 'text' },
    entries: {
      type: 'array',
      arrayFields: { outlet: { type: 'text' }, quote: { type: 'textarea' }, url: { type: 'text' } },
      defaultItemProps: { outlet: '', quote: '' },
    },
  },
  defaultProps: { title: 'Ils en parlent', entries: [] },
  render: PressReviews,
};
